import { ICompany } from "../models/company";

export const SET_COMPANY = "SET_COMPANY"

export const SetCompany = (company: ICompany) => {
    return { type: SET_COMPANY, company };
}